(function (Drupal) {
  Drupal.behaviors.marketingCookiesNotAccepted = {
    attach: function (context, settings) {
      // Check if the Drupal.eu_cookie_compliance object is available

      if (
        Drupal.eu_cookie_compliance &&
        typeof Drupal.eu_cookie_compliance.hasAgreedWithCategory === "function"
      ) {
        Drupal.eu_cookie_compliance.getAcceptedCategories();

        if (
          !Drupal.eu_cookie_compliance.hasAgreedWithCategory(
            "marketing_cookies"
          )
        ) {
          document.body.classList.add("show-cookie-consent-overlay");
        } else {
          document.body.classList.remove("show-cookie-consent-overlay");
        }
      }
    },
  };
})(Drupal);
